import React from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import TierBadge from '@wix/da-ds/pkg/Badges/TierBadge';
import { getPrimaryTier } from '../../../../../_helpers';
import SubscribeButton from '../../../../../../Button/SubscribeButton';
import s from './SubscriberThumbPaywall.scss';
var SubscriberThumbPaywall = function (_a) {
    var _b;
    var deviation = _a.deviation, isSmall = _a.isSmall, className = _a.className;
    var tier = getPrimaryTier(deviation);
    if (!tier) {
        return null;
    }
    return (React.createElement("div", { className: classnames(s['root'], isSmall && s['small'], className) },
        React.createElement(TierBadge, { isLocked: true, size: 32 }),
        React.createElement("div", { className: s['tier-price'] },
            React.createElement(Trans, { i18nKey: "deviationview.overlay.subscriber.perMonth" },
                React.createElement("span", { className: s['tier-price-amount'] }, { dollarPrice: (_b = tier.tier) === null || _b === void 0 ? void 0 : _b.dollarPrice }),
                "/month")),
        React.createElement(SubscribeButton, { tier: tier, href: tier.url })));
};
SubscriberThumbPaywall.displayName = 'SubscriberThumbPaywall';
export default SubscriberThumbPaywall;
//# sourceMappingURL=SubscriberThumbPaywall.js.map